module.exports = __webpack_public_path__ + "static/media/sessions_blue.1467fbf0.png";